module.exports = __webpack_public_path__ + "static/media/unibest-banner2.820c4b1b.png";